import { render, staticRenderFns } from "./Parametros.vue?vue&type=template&id=13373b78&scoped=true&"
import script from "./Parametros.vue?vue&type=script&lang=js&"
export * from "./Parametros.vue?vue&type=script&lang=js&"
import style0 from "./Parametros.vue?vue&type=style&index=0&id=13373b78&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13373b78",
  null
  
)

export default component.exports